export function sampleArray<T>(packets: T[], sampleRate: number): T[] {
    return packets.filter((_, i) => i % sampleRate === 0)
}
